module.exports = __webpack_public_path__ + "media/my_images/search/img01-563885ece0326b0514acd9ee76863dd1.jpg";